/**
 * Tracks the case where MSAL believes we are signed in but the API refuses the token — which is
 * exactly what a blocked sign-in domain looks like from the browser. Without this the user would
 * hit a generic "Authentication is required" error state on every screen with no way forward.
 */

let rejected = false;
const listeners = new Set<(rejected: boolean) => void>();

export function reportApiAuthRejected() {
  if (rejected) return;
  rejected = true;
  listeners.forEach((listener) => listener(true));
}

export function clearApiAuthRejected() {
  if (!rejected) return;
  rejected = false;
  listeners.forEach((listener) => listener(false));
}

export function isApiAuthRejected() {
  return rejected;
}

export function subscribeApiAuth(listener: (rejected: boolean) => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
